/** Internal origin query for worker → Nuxt SSR (not shown in browser URL). */
export const SSR_QUERY_KEY_EXPERIMENT = '_me_exp';

export const VARIATION_CONTROL = 'control';

export const SUBSCRIBE_PAGE_EXPERIMENT_ID = 'subscribe_page_plus_ai';

/** Subscribe ?x=0 / Flagsmith control arm variation code (tracking + cookie). */
export const SUBSCRIBE_VARIATION_NO_SWITCHER = 'no_switcher';

export const SUBSCRIBE_VARIATION_NO_AI = 'no_ai';

/** SSR / assign fallback when subscribe variation code is missing. */
export const SUBSCRIBE_PAGE_DEFAULT_VARIATION_CODE = SUBSCRIBE_VARIATION_NO_SWITCHER;

const VALID_VARIATION_CODES = new Set([
    VARIATION_CONTROL,
    SUBSCRIBE_VARIATION_NO_SWITCHER,
    SUBSCRIBE_VARIATION_NO_AI,
]);

/**
 * Cookie / Flagsmith variation code for subscribe. Unknown values → null.
 * `control` → GTM as `control`, same no_switcher UI. Keep in sync with worker-proxy.
 */
export function normalizeVariationCode(value) {
    if (value == null || value === '') {
        return null;
    }
    return VALID_VARIATION_CODES.has(value) ? value : null;
}

export function experimentCookieName(experimentId) {
    return `ME_exp_${experimentId}`;
}

export function isExperimentControlVariation(variationCode) {
    return variationCode == null || variationCode === '' || variationCode === VARIATION_CONTROL;
}

/**
 * Read variation code from worker-injected origin query ?_me_exp= (not in public browser URL).
 * @param {{ query?: Record<string, string | string[] | undefined> }} route
 * @returns {string|null}
 */
export function readVariationCodeFromSsrQuery(route) {
    const raw = route?.query?.[SSR_QUERY_KEY_EXPERIMENT];
    const value = Array.isArray(raw) ? raw[0] : raw;

    return normalizeVariationCode(value);
}
